export const MAX_INVITE_EMAILS = 200;

export const INVITE_MODAL_WIDTH = 560;
